import { useState, useEffect } from 'react';
import { Deck } from '../types';
import { useAuth } from '../contexts/AuthContext';
import { db } from '../config/firebase';
import { 
  collection, 
  addDoc, 
  deleteDoc, 
  doc, 
  query, 
  where, 
  onSnapshot,
  orderBy 
} from 'firebase/firestore';

export const useDecks = () => {
  const [decks, setDecks] = useState<Deck[]>([]);
  const { user } = useAuth();

  useEffect(() => {
    if (!user) {
      setDecks([]);
      return;
    }

    const q = query(
      collection(db, 'decks'),
      where('userId', '==', user.id),
      orderBy('name')
    );

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const decksData: Deck[] = [];
      querySnapshot.forEach((doc) => {
        decksData.push({ id: doc.id, ...doc.data() } as Deck);
      });
      setDecks(decksData);
    });

    return () => unsubscribe();
  }, [user]);


  const addDeck = async (name: string, formatId: string) => {
    if (!user) return;

    try {
      await addDoc(collection(db, 'decks'), {
        name,
        userId: user.id,
        formatId
      });
    } catch (error) {
      console.error('Error adding deck:', error);
      throw error;
    }
  };

  const deleteDeck = async (deckId: string) => {
    try {
      await deleteDoc(doc(db, 'decks', deckId));
    } catch (error) {
      console.error('Error deleting deck:', error);
      throw error;
    }
  };

  return {
    decks,
    addDeck,
    deleteDeck
  };
};